(function () {
    'use strict';

    angular
        .module('app')
        .controller('SMSTemplateEditCtrl', SMSTemplateEditCtrl);

    SMSTemplateEditCtrl.$inject = [
        '$location',
        '$scope',
        '$q',
        '$routeParams',
        'SMSTemplatesService',
        'EntityTemplatesService',
        'LastUpdatedService',
        'NavigationAidService',
        'DialogService',
        'UnsavedChangesService',
        'SMSTemplate',
        'ChilliUserProfileService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService',
        'DocumentTemplatesService'];

    /**
     * @ngdoc controller
     * @name SMSTemplateEditCtrl
     *
     * @description
     * Edit screen for an sms template. Add a new one, or edit an existing one.
     */
    function SMSTemplateEditCtrl(
        $location,
        $scope,
        $q,
        $routeParams,
        SMSTemplatesService,
        EntityTemplatesService,
        LastUpdatedService,
        NavigationAidService, 
        DialogService, 
        UnsavedChangesService,
        SMSTemplate,
        ChilliUserProfileService,
        ObjectSaveErrorHandlerService,
        WindowTitleService,
        DocumentTemplatesService) {

        /* jshint validthis:true */
        var vm = this;
        vm.template = {};
        vm.entityTemplates = [];
        vm.saveTemplate = saveTemplate;
        vm.copyTemplate = copyTemplate;
        vm.deleteTemplate = deleteTemplate;
        vm.loading = true;
        vm.notFound = false;
        vm.permissionDenied = false;
        vm.viewEntities = viewEntities;
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        vm.close = close;
        Object.defineProperty(vm, 'deleteEnabled', {
            get: function () { return !_.isNil(vm.template) && !_.isNil(vm.template.data) && !_.isNil(vm.template.data.Id) && vm.template.data.Id != 'new'; }
        });
        Object.defineProperty(vm, 'selectedEntityTemplate', {
            get: getSelectedEntityTemplate,
            set: setSelectedEntityTemplate
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', { get: function () {
            return LastUpdatedService.getLabel(vm.template.data);
        }
        });
        Object.defineProperty(vm, 'templateIsNew', {
            get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
        });
        Object.defineProperty(vm, 'selectedMessageDocumentTemplate', {
            get: getSelectedMessageDocumentTemplate,
            set: setSelectedMessageDocumentTemplate
        });
        vm.viewTitle = 'SMS Template';
        vm.currentTabPage = 'details';
        vm.messageDocumentTemplates = [];
        vm.toSMSContacts = [];

        activate();

        function activate() {
            updateViewTitle();

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    updateViewTitle();
                }
            });
        }

        function loadEverything() {
            var promiseList = [];
            promiseList.push(loadTemplate());
            promiseList.push(loadEntityTemplates());

            return $q.all(promiseList).then(function () {
                // Finish view-model configuration once everything critical is loaded
                UnsavedChangesService.register({
                    scope: $scope,
                    getDirtyFunction: getModelDirty,
                    saveFunction: saveTemplate,
                    unsavedItemName: 'SMS Template'
                });

                return loadEntityTemplateItems(vm.template.data.EntityTemplateId);
            });
        }

        /**
         * Load sms template into vm.template.
         *
         * @returns {Promise} A promise resolved once loading is finished. Rejects if load fails.
         */        
        function loadTemplate() {
            var getTemplatePromise;
            if (!vm.templateIsNew) {
                getTemplatePromise = SMSTemplate.get($routeParams.id);
            } else if ($routeParams.copySMSTemplateId) {
                getTemplatePromise = SMSTemplate.getCopy($routeParams.copySMSTemplateId);
            } else {
                getTemplatePromise = SMSTemplate.getNew(parseInt($routeParams.entityTemplateId));
            }

            return getTemplatePromise.then(
                function ok(template) {
                    vm.template = template;
                },
                function error(response) {
                    if (response.status === 404) {
                        vm.notFound = true;
                    } else {
                        DialogService.error('Error fetching SMS Template', response);
                    }
                    return $q.reject(response);
                });
        }

        /**
         * Load entity templates and entity template count into vm.entityTemplates and vm.entityTemplatesCount.
         *
         * @returns {Promise} A promise resolved once loading is finished, resolves regardless of error.
         */
        function loadEntityTemplates() {
            return EntityTemplatesService.query()
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                vm.entityTemplates = data.EntityTemplates;
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching Entity Templates', response);
            }
        }

        /**
         *
         * Loads all items (document templates, contacts etc.) for the specified entity template
         *
         * @returns {Promise} A promise resolved once loading is finished.
         */
        function loadEntityTemplateItems(entityTemplateId) {
            if (!_.isNil(entityTemplateId)) {
                return $q.all([loadDocumentTemplates(entityTemplateId), loadContacts(entityTemplateId)]);
            } else {
                vm.messageDocumentTemplates = [];
                vm.toSMSContacts = [];

                return $q.when(true);
            }
        }

        /**
         *
         * Load document templates
         *
         * @returns {Promise} A promise resolved once loading is finished, resolves regardless of error.
         */
        function loadDocumentTemplates(entityTemplateId) {
            var promiseList = [];
            promiseList.push(EntityTemplatesService.getDocumentTemplates(entityTemplateId, 'SMS').then(getMessageDocumentTemplatesOk).catch(getDocumentTemplatesError));

            return $q.all(promiseList);

            function getMessageDocumentTemplatesOk(data) {
                vm.messageDocumentTemplates = data;

                return loadSelectedMessageDocumentTemplate();
            }

            function getDocumentTemplatesError(response) {
                vm.error = 'The document templates were unsuccessfully retrieved.';
            }
        }

        function loadSelectedMessageDocumentTemplate() {
            if (!_.isNil(vm.template) && !_.isNil(vm.template.data) && !_.isNil(vm.template.data.Message) && vm.template.data.Message !== '' &&
                !_.some(vm.messageDocumentTemplates, function (item) { return item.Id === vm.template.data.Message; })) {
                return DocumentTemplatesService.getDocumentTemplate(vm.template.data.Message, true)
                    .then(loadSelectedMessageDocumentTemplateOk, loadSelectedMessageDocumentTemplateError);
            }
        }

        function loadSelectedMessageDocumentTemplateOk(result) {
            if (!_.isNil(result)) {
                vm.messageDocumentTemplates.push(result);
            }
        }

        function loadSelectedMessageDocumentTemplateError(response) {
            vm.error = 'The document templates were unsuccessfully retrieved.';
        }

        /**
         *
         * Load contacts
         *
         * @returns {Promise} A promise resolved once loading is finished, resolves regardless of error.
         */
        function loadContacts(entityTemplateId) {
            return EntityTemplatesService.getContacts(entityTemplateId, ['SMS'])
                    .then(getContactsOk, getContactsError);

            function getContactsOk(data) {
                vm.toSMSContacts = angular.copy(data);
            }

            function getContactsError(response) {
                vm.error = 'The sms contacts were not successfully retrieved.';
            }
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'SMS Template';

            if (!_.isNil($routeParams.id) && $routeParams.id === 'new') {
                title = 'Add ' + title;
            }

            if (!_.isNil(vm.template) && !_.isNil(vm.template.data) && !_.isNil(vm.template.data.Name) && vm.template.data.Name !== '') {
                title += ' - ' + vm.template.data.Name;
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        /**
         * @returns {bool} True if the model is dirty aka there are unsaved changes.
         */
        function getModelDirty() {
            return vm.template !== null && vm.template.dirty;
        }

        /**
         * Save the sms template
         *
         * @returns {Promise} A promise that resolves once saving is finished.
         */
        function saveTemplate() {
            var saveRequest;

            if (!_.isNil(vm.addTemplateForm) && vm.addTemplateForm.$invalid) {
                return DialogService.messageList('Error saving sms template', null, vm.addTemplateForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {

                saveRequest = angular.copy(vm.template.data);

                return SMSTemplatesService.save(saveRequest)
                    .then(saveTemplateOk, saveTemplateError);
            }

            function saveTemplateOk(response) {
                if (vm.templateIsNew) {
                    UnsavedChangesService.clearRegistration();
                    NavigationAidService.replacePage('smstemplates/' + response);
                } else {
                    return SMSTemplate.createWithData(response)
                        .then(function (template) {
                            vm.template = template;
                        });
                }
            }

            function saveTemplateError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.template.data,
                    'SMS Template',
                    vm.saveTemplate,
                    function () {
                        return SMSTemplate.get($routeParams.id)
                            .then(function (getTemplateResponse) {
                                return getTemplateResponse.data;
                            });
                    });
            }
        }

        /**
         * Deletes the sms template. The user is presented with a confirmation dialog.
         *
         * NB: This function is asynchronous.
         */
        function deleteTemplate() {
            if ($routeParams.id && $routeParams.id !== 'new') {
                vm.template.delete()
                    .then(deleteTemplateOk, deleteTemplateError);
            } else {
                promptUserToSaveForOperation('deleting');
            }

            function deleteTemplateOk(success) {
                NavigationAidService.goBack();
            }

            function deleteTemplateError(response) {
                if (!_.isNil(response)) {
                    DialogService.error('Error deleting SMS Template', response);
                }
            }
        }

        function getSelectedEntityTemplate() {
            if (_.isNil(vm.template) || _.isNil(vm.template.data) || _.isNil(vm.template.data.EntityTemplateId)) {
                return null;
            } else {
                var searchResult = _.find(vm.entityTemplates, function (i) { return i.Id === vm.template.data.EntityTemplateId; });
                return angular.isUndefined(searchResult) ? null : searchResult;
            }
        }

        function setSelectedEntityTemplate(newTemplate) {
            if (newTemplate === null) {
                vm.template.data.EntityTemplateId = null;
            } else {
                vm.template.data.EntityTemplateId = newTemplate.Id;
            }

            // Clear out these values since they are entity template specific
            vm.template.data.Message = null;
            vm.template.data.To = [];

            return loadEntityTemplateItems(vm.template.data.EntityTemplateId);
        }

        function getSelectedMessageDocumentTemplate() {
            var value = null;

            if (!_.isNil(vm.template) && !_.isNil(vm.template.data) && !_.isNil(vm.template.data.Message) && vm.template.data.Message !== '') {
                value = _.find(vm.messageDocumentTemplates, function (documentTemplate) {
                    return documentTemplate.Id === vm.template.data.Message;
                });
            }

            if (getSelectedMessageDocumentTemplate.value !== value) {
                getSelectedMessageDocumentTemplate.value = value;
            }

            return getSelectedMessageDocumentTemplate.value;
        }

        function setSelectedMessageDocumentTemplate(newTemplate) {
            var value = null;
            if (!_.isNil(newTemplate) && newTemplate !== '') {
                value = newTemplate.Id;
            }

            if (!_.isNil(vm.template) && !_.isNil(vm.template.data)) {
                vm.template.data.Message = value;
            }
        }

        /**
         * Redirects the user to a view with a copy of the current sms template.
         */
        function copyTemplate() {
            var copyUrl = 'smstemplates/new?copySMSTemplateId=';

            if (vm.templateIsNew) {
                promptUserToSaveForOperation('copying');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('SMS Template')
                        .then(function () {
                            saveTemplate().then(function () {
                                $location.url(copyUrl + vm.template.data.Id);
                            });
                        });
                } else {
                    $location.url(copyUrl + vm.template.data.Id);
                }
            }
        }

        /*
         * When conducting an operation which requires a saved sms template and the sms template is new, a 'save sms template' prompt needs to be shown
         *
         * @param {string} operationName - Name of operation that was being conducted
         */
        function promptUserToSaveForOperation(operationName) {
            return DialogService.show({
                controller: 'SaveItemDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/save-item-dialog.tmpl.html',
                locals: { name: 'sms template', operation: operationName }
            })
            .then(function () {
                return saveTemplate();
            });
        }

        function close() {
            NavigationAidService.goBack();
        }

        /**
         * Redirects the user to a list view of entities for the entity template.
        */
        function viewEntities() {
            if (vm.templateIsNew) {
                promptUserToSaveForOperation('viewing entities');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges('SMS Template')
                        .then(function () {
                            saveTemplate().then(function () {
                                $location.url('entities?entityTemplateId=' + vm.template.data.EntityTemplateId);
                            });
                        });
                } else {
                    $location.url('entities?entityTemplateId=' + vm.template.data.EntityTemplateId);
                }
            }
        }
    }
})();